import { useEffect } from "react";
import "@/App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/components/auth/AuthProvider";
import { useAuth } from "@/components/auth/AuthProvider";
import AuthCallback from "@/components/auth/AuthCallback";
import Layout from "@/components/layout/Layout";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import Clusters from "@/pages/Clusters";
import Topology from "@/pages/Topology";
import ResourceExplorer from "@/pages/ResourceExplorer";
import Monitoring from "@/pages/Monitoring";
import Analytics from "@/pages/Analytics";
import Incidents from "@/pages/Incidents";
import CostIntelligence from "@/pages/CostIntelligence";
import AIAssistant from "@/pages/AIAssistant";
import Predictive from "@/pages/Predictive";
import ConnectCluster from "@/pages/ConnectCluster";
import ManifestAnalyzer from "@/pages/ManifestAnalyzer";
import Settings from "@/pages/Settings";

// Send cookies with every request
axios.defaults.withCredentials = true;

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="w-8 h-8 rounded-full border-2 border-slate-700 border-t-indigo-400 animate-spin" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();

  // Synchronously detect session_id in URL fragment BEFORE rendering routes
  // This prevents race conditions where ProtectedRoute redirects before AuthCallback runs
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="clusters" element={<Clusters />} />
        <Route path="topology" element={<Topology />} />
        <Route path="explorer" element={<ResourceExplorer />} />
        <Route path="monitoring" element={<Monitoring />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="incidents" element={<Incidents />} />
        <Route path="cost" element={<CostIntelligence />} />
        <Route path="assistant" element={<AIAssistant />} />
        <Route path="predictive" element={<Predictive />} />
        <Route path="connect" element={<ConnectCluster />} />
        <Route path="manifest-analyzer" element={<ManifestAnalyzer />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
